import { getMeridianStatus } from '../getMeridianStatus';
import { meridianToMilitary } from '../meridianToMilitary';

const militaryTimeToSeconds = (militaryTime: string): number => {
  const { isMeridian } = getMeridianStatus(militaryTime);
  const [hour, min] = militaryTime.split(':').map((timeChunk) => parseInt(timeChunk));
  if (isMeridian) {
    console.error(`Time passed is meridian time, this requires military time, but received ${militaryTime}.`);
    const _militaryTime = meridianToMilitary(militaryTime);
    return militaryTimeToSeconds(_militaryTime);
  }
  return hour * 3600 + min * 60;
};

export default militaryTimeToSeconds;
